import { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/pages/LandingPage.css';

// Import Components
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import PinExtensionModal from './components/PinExtensionModal';
import ScrollToTop from './components/ScrollToTop';

// Import Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MyGuides from './pages/MyGuides';
import ExploreGuides from './pages/ExploreGuides';
import SharePage from './pages/SharePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import ContactUs from './pages/ContactUs';
import AuthCallbackPage from './pages/AuthCallbackPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import WorkspaceDashboard from './pages/WorkspaceDashboard';
import GuideAnalytics from './pages/GuideAnalytics';
import ProfilePage from './pages/ProfilePage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PlayGuide from './pages/PlayGuide';
import GuideDetailPage from './pages/GuideDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import FaqPage from './pages/FaqPage';
import ErrorPage from './pages/ErrorPage';
import UninstallFeedback from './pages/UninstallFeedback';

// Initialize GA4 once
// if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
// }

// Inner component so it can access useLocation (must be inside Router)
function AppContent() {
  const location = useLocation();

  // A failed page-loading API call (see api.js) swaps the routes for ErrorPage;
  // navigating anywhere clears it.
  const [apiError, setApiError] = useState(null);
  useEffect(() => {
    const onError = (e) => setApiError(e.detail);
    window.addEventListener('api:error', onError);
    return () => window.removeEventListener('api:error', onError);
  }, []);
  useEffect(() => setApiError(null), [location.pathname]);

//   useEffect(() => {
//   if (process.env.NODE_ENV === 'production') {
//     ReactGA.send({
//       hitType: 'pageview',
//       page: location.pathname + location.search,
//     });
//   }
// }, [location]);
useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <PinExtensionModal />
      <main style={{ flex: 1 }}>
        <ScrollToTop />
        {apiError ? <ErrorPage code={apiError} onRetry={() => window.location.reload()} /> : (
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/my-guides" element={<ProtectedRoute><MyGuides /></ProtectedRoute>} />
          <Route path="/explore" element={<ExploreGuides />} />
          <Route path="/share" element={<SharePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/auth/verify" element={<VerifyEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
          <Route path="/workspace" element={<ProtectedRoute><WorkspaceDashboard /></ProtectedRoute>} />
          <Route path="/analytics/:guideId" element={<ProtectedRoute><GuideAnalytics /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/play/:guideId" element={<PlayGuide />} />
          <Route path="/guides/:guideId" element={<GuideDetailPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/uninstall" element={<UninstallFeedback />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}